/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    pre: "pre",
    code: "code",
    span: "span",
    p: "p",
    a: "a",
    h2: "h2",
    ul: "ul",
    li: "li",
    strong: "strong",
    em: "em"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.pre, {
    className: "language-graphql"
  }, React.createElement(_components.code, {
    className: "language-graphql"
  }, React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  ", React.createElement(_components.span, {
    className: "token property-query"
  }, "allMarkdownRemark"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token attr-name"
  }, "filter"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token attr-name"
  }, "frontmatter"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token attr-name"
  }, "title"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token attr-name"
  }, "ne"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token string"
  }, "\"\""), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n    ", React.createElement(_components.span, {
    className: "token property"
  }, "totalCount"), "\n    ", React.createElement(_components.span, {
    className: "token object"
  }, "edges"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n      ", React.createElement(_components.span, {
    className: "token object"
  }, "node"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n        ", React.createElement(_components.span, {
    className: "token object"
  }, "frontmatter"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n          ", React.createElement(_components.span, {
    className: "token property"
  }, "title"), "\n        ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n      ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n    ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n  ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n")), "\n", React.createElement(_components.p, null, "In this query ", React.createElement(_components.code, null, "filter"), " and the ", React.createElement(_components.code, null, "ne"), " (not equals) operator is used to show only results that have a title. You can find a good video tutorial on this ", React.createElement(_components.a, {
    href: "https://www.youtube.com/watch?v=Lg1bom99uGM"
  }, "here"), "."), "\n", React.createElement(_components.p, null, "Gatsby relies on ", React.createElement(_components.a, {
    href: "https://www.npmjs.com/package/sift"
  }, "Sift"), " to enable MongoDB-like query syntax for object filtering. This allows Gatsby to support operators like ", React.createElement(_components.code, null, "eq"), ", ", React.createElement(_components.code, null, "ne"), ", ", React.createElement(_components.code, null, "in"), ", ", React.createElement(_components.code, null, "regex"), " and querying nested fields through the ", React.createElement(_components.code, null, "__"), " connector."), "\n", React.createElement(_components.p, null, "It is also possible to filter on multiple fields - just separate the individual filters by a comma (works as an AND):"), "\n", React.createElement(_components.pre, {
    className: "language-javascript"
  }, React.createElement(_components.code, {
    className: "language-javascript"
  }, React.createElement(_components.span, {
    className: "token literal-property property"
  }, "filter"), React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token literal-property property"
  }, "contentType"), React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "in"), React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "["), React.createElement(_components.span, {
    className: "token string"
  }, "\"post\""), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token string"
  }, "\"page\""), React.createElement(_components.span, {
    className: "token punctuation"
  }, "]"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token literal-property property"
  }, "draft"), React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token literal-property property"
  }, "eq"), React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token boolean"
  }, "false"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n")), "\n", React.createElement(_components.h2, null, "Complete list of possible operators"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "eq"), ": short for ", React.createElement(_components.strong, null, "equal"), ", must match the given data exactly"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "ne"), ": short for ", React.createElement(_components.strong, null, "not equal"), ", must be different from the given data"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "regex"), ": short for ", React.createElement(_components.strong, null, "regular expression"), ", must match the given pattern. Note that backslashes need to be escaped ", React.createElement(_components.em, null, "twice"), ", so ", React.createElement(_components.code, null, "/\\w+/"), " needs to be written as ", React.createElement(_components.code, null, "\"/\\\\\\\\w+/\""), "."), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "glob"), ": short for ", React.createElement(_components.strong, null, "global"), ", allows to use wildcard ", React.createElement(_components.code, null, "*"), " which acts as a placeholder for any non-empty string"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "in"), ": short for ", React.createElement(_components.strong, null, "in array"), ", must be an element of the array"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "nin"), ": short for ", React.createElement(_components.strong, null, "not in array"), ", must NOT be an element of the array"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "gt"), ": short for ", React.createElement(_components.strong, null, "greater than"), ", must be greater than given value"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "gte"), ": short for ", React.createElement(_components.strong, null, "greater than or equal"), ", must be greater than or equal to given value"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "lt"), ": short for ", React.createElement(_components.strong, null, "less than"), ", must be less than given value"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "lte"), ": short for ", React.createElement(_components.strong, null, "less than or equal"), ", must be less than or equal to given value"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "elemMatch"), ": short for ", React.createElement(_components.strong, null, "element match"), ", this indicates that the field you are filtering will return an array of elements, on which you can apply a filter using the previous operators"), "\n"), "\n", React.createElement(_components.p, null, "If you want to understand more how these filters work, looking at the corresponding ", React.createElement(_components.a, {
    href: "https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby/src/schema/__tests__/run-query.js"
  }, "tests"), " in the codebase could be very useful."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
